export default {

    state: {
      dataMonitoramento: new Date()
    },
  
    mutations: {
        setDataMonitoramento(state, payload) {
          state.dataMonitoramento = payload;
      }
    },
  
    getters: {
      getDataMonitoramento(state) {
          return state.dataMonitoramento;
      }
    },

    actions: {
        setDataMonitoramento({commit}, dataMonitoramento){
            commit('setDataMonitoramento', dataMonitoramento);
          },
    },
    
  }